import './infoBox.css';

export const InfoBox = ({ className, children }) => {
    return <div className={`info-box ${className}`}>{children}</div>;
};

export default InfoBox;
